import {Component, inject, OnInit} from '@angular/core';
import {DialogService, DynamicDialogConfig} from 'primeng/dynamicdialog';
import {TranslateService} from '@ngx-translate/core';
import {ViewHelper} from '../../../shared/helper/view-helper';
import {DialogHelper} from '../../../shared/helper/dialog-helper';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
    selector: 'app-update-history',
    templateUrl: './update-history.component.html',
    styleUrls: ['./update-history.component.scss'],
    standalone: true
})
export class UpdateHistoryComponent implements OnInit
{
  private config = inject(DynamicDialogConfig);
  public sanitizer = inject(DomSanitizer);

  height = 500;
  url: string;

  public static showDialog(dialogService: DialogService, translate: TranslateService, url: string): void
  {
    dialogService.open(
      UpdateHistoryComponent,
      DialogHelper.createBasicConfig(
      {
        header: translate.instant('UPDATE_HISTORY'),
        width: ViewHelper.isMobile() ? '100%' : '90%',
        height: '95%',
        data: {url}
      })
    );
  }

  ngOnInit(): void
  {
    this.url = this.config.data.url;
    this.onResize();
  }

  public onResize(): void
  {
    // Fenster wird mit 90% Höhe angezeigt -> positionTop muss also dynamisch berechnet werden
    const heightRest = window.innerHeight * 95 / 100;
    this.height = heightRest - 100;
  }
}
